import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import PageHeaderComponent from "@/components/global/PageHeaderComponent.vue";
import InternalArchiveContentComponent from "@/modules/main/components/internal-tools/InternalArchiveContentComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InternalArchiveView',
  setup(__props) {

const searchLearner = ref("");

const handleSearchQueryUpdate = (searchQuery: string) => {
  searchLearner.value = searchQuery;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageHeaderComponent, {
      pageHeading: 'Internal',
      filterVariant: "gradeSubject",
      includeAll: true,
      "onUpdate:searchQuery": handleSearchQueryUpdate
    }),
    _createVNode(InternalArchiveContentComponent, {
      showHiddenButton: true,
      searchQuery: searchLearner.value
    }, null, 8, ["searchQuery"])
  ], 64))
}
}

})